import type { SVGProps } from 'react';
import ZepIcon from '../ZepIcon';
export const CaretUpIcon = ZepIcon((props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path fill={props.fill || `currentColor`} d="m17 14-5-6-5 6z" />
  </svg>);